module.exports = __webpack_public_path__ + "img/yw4.822e3926.png";